import type { JSX } from "react";

export interface JourneyItem {
  imgSrc: string;
  alt: string;
  title: string;
  description: string;
}

interface JourneyListItemProps {
  item: JourneyItem;
}

export function JourneyListItem({ item }: JourneyListItemProps): JSX.Element {
  return (
    <div className="flex flex-row">
      <div className="w-30 h-30 min-w-25 aspect-square xs:max-w-40 xs:max-h-40 xs:w-auto xs:h-auto">
        <img src={item.imgSrc} alt={item.alt} className="w-full h-full object-contain rounded-xl" role="presentation" />
      </div>
      <div className="self-center pl-4 flex flex-col">
        <div className="m-0 text-black font-bold text-xl mt-0 first-letter:capitalize">{item.title}</div>
        <div className="m-0 text-black font-normal text-base mt-1 first-letter:capitalize">{item.description}</div>
      </div>
    </div>
  );
}
